import { GetServerSidePropsContext } from 'next'
import { isAuthenticated } from 'utilities/isAuthenticated'

export { CovidPage as default } from 'components/pages/static/Covid'

export const getServerSideProps = async ({ req }: GetServerSidePropsContext) => {
  const authorization = await isAuthenticated(req)

  return {
    props: {
      preloadedState: {
        authorization,
      },
    },
  }
}
